export const FETCH_END = "setArticles";
export const FETCH_START = "setLoading";
export const PURGE_AUTH = "logOut";
export const SET_ARTICLE = "setArticle";
export const SET_AUTH = "setUser";
export const SET_COMMENTS = "setComments";
export const SET_ERROR = "setError";
export const SET_PROFILE = "setProfile";
export const SET_TAGS = "setTags";
export const TAG_ADD = "addTag";
export const TAG_REMOVE = "removeTag";
export const UPDATE_ARTICLE_IN_LIST = "updateAricleInList";
export const RESET_STATE = "resetModuleState";
export const SET_NETWORK = "setNetwork";
export const SET_NETWORK_LOADING = "setNetworkLoading";
export const SET_SERVICES_STATUS = "setServicesStatus";
export const SET_NETWORK_WIFI_LIST = "setWiFiList";
export const SET_NETWORK_WIFI_WPS_STATUS = "setNetworkWifiWpsStatus";
export const SET_NETWORK_STATUS = "setNetworkStatus";


